(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

	$('[data-collapse-children]').each(function () {
		var wrap = $(this);
		var num = wrap.attr('data-collapse-children') || 1;
		var children = wrap.find('> *');
		var toggle = wrap.parent().find('[data-collapse-children-toggle]'); // TODO: Maybe risky...

		// Hide all but num first
		children.filter(function () {
			var which = children.index(this) + 1;

			return which > num;
		}).addClass('collapse-children-hide');

		// HACK: Don't show num more on click, show ALL of them
		num = children.length - num;

		// Show num more on click
		toggle.on('click', function (e) {
			e.preventDefault();

			children.filter('.collapse-children-hide').filter(function (i) {
				return i < num;
			}).removeClass('collapse-children-hide');

			if (children.filter('.collapse-children-hide').length === 0) {
				toggle.hide();
			}
		});
	});
})();
